import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "m7.688 10.54-4.22-4.22a.393.393 0 0 1-.14-.304c0-.12.047-.222.14-.305l.25-.25a.424.424 0 0 1 .313-.125c.125 0 .23.042.313.125L8 9.117l3.656-3.656a.424.424 0 0 1 .313-.125c.125 0 .229.042.312.125l.25.266c.094.083.14.182.14.296a.433.433 0 0 1-.14.313l-4.219 4.203a.424.424 0 0 1-.312.125.424.424 0 0 1-.313-.125Z"
    }, null, -1)
  ])))
}
export default { render: render }